<template>
  <div>
    <div class="nav-item d-md-none" v-if="reflectionsPars.services.length > 0">
      <div class="d-flex pb-0 text-bold" id="filters-toggler" @click="toggleFilters">
        <span v-if="filterIsVisibleMobile" class="text-bold d-flex justify-content-between w-100">
          {{ trans("journal.reflections.show_options") }}
          <b-icon-chevron-down variant="secondary" class="chevron" />
        </span>
        <span v-else class="text-bold d-flex justify-content-between w-100">
          {{ trans("journal.reflections.hide_options") }}
          <b-icon-chevron-up variant="secondary" class="chevron" />
        </span>
      </div>
    </div>

    <div v-if="isLoading" class="d-flex justify-content-center h-100 align-items-center">
      <b-spinner class="align-middle" variant="secondary" />
    </div>
    <div v-else-if="reflectionsPars.services.length == 0" class="text-center">
      <b-img src="/images/journal/reflections_empty.svg" />
      <p class="font-weight-bold mb-0">{{ trans("journal.reflections.empty.p1") }}</p>
      <p>{{ trans("journal.reflections.empty.p2") }}</p>
      <b-button
        variant="secondary"
        class="font-weight-bold"
        :to="{ name: 'servicedashboard' }"
        @click="trackReflectionTrainingEvent"
      >
        {{ trans("journal.reflections.empty.button") }}
      </b-button>
    </div>
    <div v-else class="row justify-content-center my-4 pb-5">
      <div class="col-12 col-md-4" :class="filterIsVisibleMobile ? 'd-none d-md-block' : 'd-block'">
        <journal-reflections-filters
          v-on:getReflections="
            loadReflections({
              page: reflectionsPars.currentPage,
              order: $event.order,
              from: $event.from,
              to: $event.to,
              serviceId: $event.serviceId,
              serviceType: $event.serviceType,
            })
          "
          :services="reflectionsPars.services"
          :serviceId="reflectionsPars.serviceId"
          :serviceType="reflectionsPars.serviceType"
          :from="reflectionsPars.from"
          :to="reflectionsPars.to"
          :orderBy="reflectionsPars.order"
        />
      </div>
      <div class="col-12 col-md-8">
        <journal-reflections-content
          @loadMoreReflections="loadMoreReflections"
          @resetFilters="resetFilters"
        />
      </div>
    </div>
  </div>
</template>

<script>
import JournalReflectionsFilters from "../../organisms/journal/JournalReflectionsFilters";
import JournalReflectionsContent from "../../organisms/journal/JournalReflectionsContent";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "JournalReflections",
  components: { JournalReflectionsFilters, JournalReflectionsContent },
  data() {
    return {
      filterIsVisibleMobile: true,
    };
  },
  computed: {
    ...mapGetters({
      isLoading: "journal/getServicesLoading",
      reflections: "journal/getReflections",
      reflectionsPars: "journal/getReflectionsPars",
    }),
  },
  methods: {
    ...mapMutations({
      setReflectionsSearchPars: "journal/setReflectionsSearchPars",
      setReflectionsLoadingMore: "journal/setReflectionsLoadingMore",
    }),
    ...mapActions({
      loadReflections: "journal/loadReflections",
    }),
    async loadMoreReflections() {
      this.setReflectionsLoadingMore(true);
      await this.loadReflections({
        page: this.reflectionsPars.currentPage + 1,
        order: this.reflectionsPars.order,
        from: this.reflectionsPars.from,
        to: this.reflectionsPars.to,
        serviceId: this.reflectionsPars.serviceId,
        serviceType: this.reflectionsPars.serviceType,
      });
      this.setReflectionsLoadingMore(false);
    },
    toggleFilters() {
      this.filterIsVisibleMobile = !this.filterIsVisibleMobile;
    },
    trackReflectionTrainingEvent() {
      trackEvent("JournalReflectionStartTraining", {});
    },
    resetFilters() {
      this.setReflectionsSearchPars({
        from: "",
        to: "",
        order: "desc",
        currentPage: 1,
        lastPage: 1,
      });
      this.loadReflections({
        page: this.reflectionsPars.currentPage,
        order: this.reflectionsPars.order,
        from: this.reflectionsPars.from,
        to: this.reflectionsPars.to,
        serviceId: this.reflectionsPars.serviceId,
        serviceType: this.reflectionsPars.serviceType,
      });
    },
  },
  mounted() {
    trackEvent("JournalReflectionView", {});
  },
};
</script>

<style scoped lang="scss">
.chevron {
  border: 2px solid $color-orange;
  border-radius: 100%;
  width: 1.5rem;
  height: 1.5rem;
  padding: 0.25rem;
}
</style>
